.wrapper {
  display: flex;
  max-height: 100%;
  height: 100%;
  width: 100%;
}

.content {
  flex: 1;

  @media (min-width: $bp-medium) {
    padding: 0.4rem 0.4rem 0.4rem 0;
  }
}

.content-container {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  background: var(--content-bg-color);
  overflow: auto;

  @media (min-width: $bp-medium) {
    border: 1px var(--content-border-color) solid;
    border-radius: 4px;
  }
}

.screens {
  width: 100%;
  max-width: 64rem;
  margin: 6.4rem auto;
}

.menu-container {
  padding: 0 1.6rem;
  flex: 1;
  width: 100%;
}

.settings-title {
  font-style: normal;
  font-weight: 500;
  font-size: 1.6rem;
}

.header {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin: 2.4rem 0 1.6rem 2.4rem;
  color: var(--text-color-white);
}

.back-button {
  font-size: 1.4rem;
  line-height: 1.6rem;
  color: #7a8296;
  text-decoration: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: all 0.1s ease-out 0s;

  svg {
    margin-right: 0.6rem;
    width: 1.2rem;
    height: 1.2rem;
    fill: #7a8296;
    transform: rotate(180deg);
  }

  span {
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 1.69rem;
  }

  &:hover {
    cursor: pointer;
    color: #fff;

    svg {
      fill: #fff;
    }
  }
}
